import ElThTree from './packages/elthtree/index'
import demo from './packages/demo/index'
// import SecondaryButton from './packages/button/index'
import checkboxtags from './packages/checkboxtags/index'
import ThDrawer from './packages/drawer/index'
import '../theme/index.css'
import './packages/button/iconfont.css'
// ...如果还有的话继续添加

const components = [
  ElThTree,
  demo,
  ThDrawer,
  checkboxtags

  // ...如果还有的话继续添加
]

const install = function(Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  ElThTree,
  checkboxtags,
  ThDrawer,
  demo
  // ...如果还有的话继续添加
}



// WEBPACK FOOTER //
// ./src/index.js